/** Generic file for common utility */

/**
 * Function which hide partially the email (for security reason)
 * @param email The email to hide (if not provided return '')
 * @returns the email partially hidden
 */
export const hideEmailDetails = (email?: string | null) => {
    if (!email) return '';
    const split = email.split('@');
    return `${split[0][0]}***${split[0][split[0].length - 1]}@${split[1]}`;
}

/**
 * Function which hide partially the phone number (for security reason)
 * @param phone The phone number to hide (if not provided return '')
 * @returns The phone number partially
 */
export const hidePhoneDetails = (phone?: string | null) => {
    if (!phone) return '';
    return `***${phone.substring(phone.length - 4)}`
}

/** 
 * Function which simply check if the email provided is a valid email
 * @param The input to check
 * @return boolean true if valid email, false otherwise
 */
export const isEmailValid = (input: string): boolean => {
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    return !!input.match(validRegex);
}

/** Reusable delay function */
export function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/** Type which allow to make any props a loadable props */
export type PropsWithLoadingState<T> = (T & { loading?: false }) | (T extends Array<any> ? { loading: true, length?: number } : (Partial<T> & { loading: true }));

/** Type which allow to make any props a loadable props */
export type PropsWithErrorState<T> = (T & { error?: false }) | (T extends Array<any> ? { error: true | { message: string, onRetryClick?: () => void } } : (Partial<T> & { error: true | { message: string, onRetryClick?: () => void } }));
